import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { CompanyStore } from '../store/company.store';

export const CasinoGuard: CanActivateFn = () => {
  const viewConfig = inject(CompanyStore).viewConfigSignal();
  const company = inject(CompanyStore).companySignal();
  if (viewConfig?.casino_screen && 'enable' in viewConfig?.casino_screen) {
    return viewConfig?.casino_screen?.enable;
  } else {
    return company?.casino;
  }
};
